import React, {useContext, useState} from "react";
import cn from "classnames";
import styles from "./PutSale.module.sass";
import TextInput from "../TextInput";
import FollowSteps from "../FollowSteps";
import {message} from 'antd';
import {toWei} from "web3-utils"
import {Web3Context} from "../../contexts/Web3Context";

message.config({top: 100, duration: 5, maxCount: 3,});

const PutSale = ({className, item, onOutsideClick}) => {
  const [price, setPrice] = useState('');
  const [submitResult, setSubmitResult] = useState();

  const {isConnected, isCorrectNetwork} = useContext(Web3Context);

  const putOnSale = async (event) => {
    event.preventDefault();

    try {
      if (!item || !item.hasOwnProperty('token_id')) {
        alert('!')
        return false;
      }
      const weiPrice = toWei(`${price}`, 'ether');

      setSubmitResult({
        slug: item.seo_url,
        price: weiPrice,
        readyUrl: 'reload',
      });
    } catch (er) {
      console.error(er);
      return false;
    }
  }

  const handlePrice = (event) => {
    setPrice(event.target.value.replace(',','.'));
  };

  return (
    <div className={cn(className, styles.sale)}>
      {!submitResult && isConnected && isCorrectNetwork && <>
        <div className={cn("h4", styles.title)}>Put on sale!</div>
        <div className={styles.table}>
          <div className={styles.row}>
            <div className={styles.col}>Enter price</div>
            <div className={styles.col}><TextInput autoFocus value={price} onChange={handlePrice}/></div>
          </div>
        </div>
        <div className={styles.btns}>
          <button className={cn("button", styles.button)} onClick={putOnSale}>Continue</button>
          <button className={cn("button-stroke", styles.button)} onClick={onOutsideClick}>Cancel</button>
        </div>
      </>}
      {submitResult && isConnected && isCorrectNetwork && <FollowSteps instructions={submitResult}/>}
    </div>
  );
};

export default PutSale;
